export default __webpack_public_path__ + "static/media/hero-bg.7458e602.jpg";